import axios from '@/axios.js'	

export default {
	namespaced: true,
	state: {

	},
	actions: {
		fetchMarks({ commit }, { courseId, conceptId, page, perPage }) {
			return axios.get(`/examGrade/courses/${courseId}/grades`, {
				params: { conceptId, page, perPage }
			}).then(({ data }) => {
				return { data: data.items, total: data.totalCount };
			})
		},
		fetchStudentMarks(_, { studentId, courseId, conceptId, isAbsent }) {
			return axios.get(`/examGrade/students/${studentId}/grades`, {
				params: {
					courseId,
					conceptId,
					isAbsent,
					page: 1,
					perPage: 200
				} 
			}).then(({ data }) => {
				return data.items[0] || {};
			})
		},

		fetchStudentsMarks(_, { courseId, conceptId }) {
			return axios.get('/ExamGrade/students-grades', {
				params: {
					courseId,
					conceptId,
					hasGrade: true
				} 
			}).then(({ data }) => data);
		},

		update(_, { studentId, mark, notes, date, isAbsent, examTopicId }) {
			return axios.post(`/examGrade/examTopics/${examTopicId}/grades`, {
				studentId,
				mark,
				notes,
				date,
				isAbsent,
			}).then(({ data }) => {
				return data;
			})
		},

		updateStudentMarks({ commit }, { studentId, marks }) {
			const data = marks.map(c => ({
				studentId: studentId,
				mark: c.mark,
				notes: c.notes,
				date: c.date,
				isAbsent: c.isAbsent,
				exam_topicId: c.examTopicId,
			}))
			return axios.post('/examGrade/grades/bulk', data);
		}
	}
}
